'use client';

import { HeroBanner } from '@/components/frontend/common/hero-banner';
import { ContactInfoCards } from '@/components/frontend/contact/contact-info-cards';
import { ContactAddressSection } from '@/components/frontend/contact/contact-address-section';
import { ContactForm } from '@/components/frontend/common/contact-form';
import { SectionWrapper } from '@/components/ui/section-wrapper';
import { Typography } from '@/components/ui/typography';
import { useTranslations } from 'next-intl';

export function ContactPageContent() {
    const t = useTranslations('home.contact');

    return (
        <div className="min-h-screen bg-white dark:bg-gray-950">
            {/* Hero Banner */}
            <HeroBanner
                page="contact"
                className="border-b border-gray-200 dark:border-gray-900"
            />

            {/* Contact Info Cards (Email, Phone, WhatsApp) */}
            <SectionWrapper variant="default" padding="md" className="bg-white dark:bg-gray-950">
                <div className="container mx-auto px-4">
                    <div className="w-full">
                        <ContactInfoCards />
                    </div>
                </div>
            </SectionWrapper>

            <SectionWrapper variant="gradient" padding="md" className="bg-white dark:bg-gray-950">
                <div className="container mx-auto px-4">
                    <div className="grid lg:grid-cols-2 gap-8 lg:gap-12">
                        <div>
                            <ContactAddressSection />
                        </div>
                        <div>
                            <div className="rounded-2xl p-6 md:p-8 lg:p-8 border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 shadow-[0_14px_40px_rgba(15,23,42,0.08)] dark:shadow-[0_18px_50px_rgba(0,0,0,0.45)]">
                                <Typography variant="h4" className="mb-4 text-lg text-gray-900 dark:text-white">
                                    {t('title')}
                                </Typography>
                                <ContactForm source="contact" />
                            </div>
                        </div>
                    </div>
                </div>
            </SectionWrapper>
        </div>
    );
}

